export default "__VITE_ASSET__D_Kf99UB__"